// src/components/AddItemForm.js
import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Paper,
  Grid,
  Typography,
  CircularProgress,
  Alert,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore, AddCircle, RemoveCircle } from "@mui/icons-material";
import { getToken, base_url } from "../../../config/config";

const AddItemForm = ({ invoiceId, onItemAdded }) => {
  const initialAbmessang = [
    {
      name: "Länge",
      unit: "mm",
      value: "",
    },
  ];

  const [itemData, setItemData] = useState({
    position: "",
    singleStuckCost: "",
    numberOfStuck: "",
    totalStuckCost: "",
    ANR: "",
    percentage: "",
    percentage2: "",
    description: "",
    totalTon: "",
    costPerTon: "",
    bestullungNr: "",
    rechnuunglefrant: "",
    aufragNr: "",
    Wandstärke: "",
    Material1: "",
    Material2: "",
    Material3: "",
    Material4: "",
    type: "bestellung",
    Abmessang: initialAbmessang,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setItemData({
      ...itemData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAbmessungChange = (index, field, value) => {
    const newAbmessang = [...itemData.Abmessang];
    newAbmessang[index][field] = value;
    setItemData({
      ...itemData,
      Abmessang: newAbmessang,
    });
  };

  const addAbmessung = () => {
    setItemData({
      ...itemData,
      Abmessang: [
        ...itemData.Abmessang,
        { name: "Länge", unit: "mm", value: "" },
      ],
    });
  };

  const removeAbmessung = (index) => {
    const newAbmessang = [...itemData.Abmessang];
    newAbmessang.splice(index, 1);
    setItemData({
      ...itemData,
      Abmessang: newAbmessang,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const payload = {
        items: [itemData],
      };
      const response = await axios.post(
        `${base_url}/v1/uploadRechnungs/${invoiceId}/addItems`,
        payload,
      );
      alert(response.data.message);
      onItemAdded(response.data.invoice);
      setItemData({
        position: "",
        singleStuckCost: "",
        numberOfStuck: "",
        totalStuckCost: "",
        ANR: "",
        percentage: "",
        percentage2: "",
        description: "",
        totalTon: "",
        costPerTon: "",
        bestullungNr: "",
        rechnuunglefrant: "",
        aufragNr: "",
        Wandstärke: "",
        Material1: "",
        Material2: "",
        Material3: "",
        Material4: "",
        type: "bestellung",
        Abmessang: initialAbmessang,
      });
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to add item");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 4, marginBottom: 4 }}>
      <Typography variant='h6' gutterBottom>
        Add Item to Invoice ID: {invoiceId}
      </Typography>
      {error && (
        <Alert severity='error' sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* Position */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Position'
              name='position'
              value={itemData.position}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          {/* Single Stuck Cost */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Single Stuck Cost'
              name='singleStuckCost'
              type='number'
              value={itemData.singleStuckCost}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Number Of Stuck */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Number Of Stuck'
              name='numberOfStuck'
              type='number'
              value={itemData.numberOfStuck}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Total Stuck Cost */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Total Stuck Cost'
              name='totalStuckCost'
              type='number'
              value={itemData.totalStuckCost}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* ANR */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='ANR'
              name='ANR'
              value={itemData.ANR}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Percentage */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Percentage'
              name='percentage'
              type='number'
              value={itemData.percentage}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Percentage2 */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Percentage2'
              name='percentage2'
              type='number'
              value={itemData.percentage2}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Description */}
          <Grid item xs={12}>
            <TextField
              label='Description'
              name='description'
              value={itemData.description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Grid>
          {/* Total Ton */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Total Ton'
              name='totalTon'
              type='number'
              value={itemData.totalTon}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Cost Per Ton */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Cost Per Ton'
              name='costPerTon'
              type='number'
              value={itemData.costPerTon}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Abmessang Section */}
          <Grid item xs={12}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls='abmessang-content'
                id='abmessang-header'>
                <Typography>Abmessang</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {itemData.Abmessang.map((abm, index) => (
                  <Box
                    key={index}
                    sx={{
                      mb: 2,
                      border: "1px solid #ccc",
                      padding: 2,
                      borderRadius: 2,
                    }}>
                    <Grid container spacing={2} alignItems='center'>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth>
                          <InputLabel id={`abm-name-label-${index}`}>
                            Name
                          </InputLabel>
                          <Select
                            labelId={`abm-name-label-${index}`}
                            label='Name'
                            value={abm.name}
                            onChange={(e) =>
                              handleAbmessungChange(
                                index,
                                "name",
                                e.target.value,
                              )
                            }>
                            <MenuItem value='Länge'>Länge</MenuItem>
                            <MenuItem value='Breite'>Breite</MenuItem>
                            <MenuItem value='Höhe'>Höhe</MenuItem>
                            <MenuItem value='Durchmesser'>Durchmesser</MenuItem>
                            <MenuItem value='Radius'>Radius</MenuItem>
                            <MenuItem value='Tiefe'>Tiefe</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth>
                          <InputLabel id={`abm-unit-label-${index}`}>
                            Unit
                          </InputLabel>
                          <Select
                            labelId={`abm-unit-label-${index}`}
                            label='Unit'
                            value={abm.unit}
                            onChange={(e) =>
                              handleAbmessungChange(
                                index,
                                "unit",
                                e.target.value,
                              )
                            }>
                            <MenuItem value='mm'>mm</MenuItem>
                            <MenuItem value='cm'>cm</MenuItem>
                            <MenuItem value='m'>m</MenuItem>
                            <MenuItem value='inch'>inch</MenuItem>
                            <MenuItem value='ft'>ft</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label='Value'
                          type='number'
                          value={abm.value}
                          onChange={(e) =>
                            handleAbmessungChange(
                              index,
                              "value",
                              e.target.value,
                            )
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={1}>
                        <IconButton
                          color='error'
                          onClick={() => removeAbmessung(index)}
                          disabled={itemData.Abmessang.length === 1}>
                          <RemoveCircle />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
                <Button
                  variant='outlined'
                  startIcon={<AddCircle />}
                  onClick={addAbmessung}>
                  Add Abmessang
                </Button>
              </AccordionDetails>
            </Accordion>
          </Grid>
          {/* Bestullung Nr */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Bestullung Nr'
              name='bestullungNr'
              value={itemData.bestullungNr}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Rechnuunglefrant */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Rechnuunglefrant'
              name='rechnuunglefrant'
              value={itemData.rechnuunglefrant}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Aufrag Nr */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Aufrag Nr'
              name='aufragNr'
              value={itemData.aufragNr}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Wandstärke */}
          <Grid item xs={12} sm={6}>
            <TextField
              label='Wandstärke'
              name='Wandstärke'
              type='number'
              value={itemData.Wandstärke}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {/* Material Fields */}
          {["Material1", "Material2", "Material3", "Material4"].map(
            (material, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <TextField
                  label={material}
                  name={material}
                  value={itemData[material]}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
            ),
          )}
          {/* Type */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id='type-label'>Type</InputLabel>
              <Select
                labelId='type-label'
                label='Type'
                name='type'
                value={itemData.type}
                onChange={handleChange}
                required>
                <MenuItem value='bestellung'>Bestellung</MenuItem>
                <MenuItem value='anfrag'>Anfrag</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* Submit Button */}
          <Grid item xs={12}>
            <Button
              type='submit'
              variant='contained'
              color='secondary'
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} />}>
              {loading ? "Adding..." : "Add Item"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default AddItemForm;
